module.exports = __webpack_public_path__ + "img/home-storage.d5411610.svg";